import React, { Component } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { CgImage } from "react-icons/cg";
import { HiOutlineArrowsExpand } from "react-icons/hi";
import { IoTrashBinOutline } from "react-icons/io5";
import ImageUploading from "react-images-uploading";
import { Modal, ModalBody } from "reactstrap";
import { createMedias, personalizedProduct } from "./services";
import { Redirect } from "react-router-dom";
import Spinner from "../../../base/features/micro/Spinner";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";
import { getShopUid } from "../../../settings/domainManager";
import { navigate_to_shop_from_url } from "../../../navigator/user/shop";

class PersonalizedProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      recordImages: [],
      des: "",
      redirect: false,
      lightbox: false,
      pending: false,
      imageDetail: false,
      imageIndex: null,
      coverImage: null,
      image: null,
    };
  }
  addMedia() {
    this.setState({ pending: true });
    const formData = new FormData();
    let shop_uid = getShopUid();
    formData.append("location", shop_uid);
    if (this.state.images.length > 0) {
      formData.append("file", this.state.images[0].file);
    }
    createMedias(formData).then((items) => {
      if (items) {
        var newImages = this.state.recordImages;
        newImages.push(items);
        this.setState({ recordImages: newImages, image: [], pending: false });
        if (!this.state.coverImage) {
          this.setState({ coverImage: items });
        }
      }
    });
  }

  imageRemove() {
    let recordImages = this.state.recordImages;
    recordImages.splice(this.state.imageIndex, 1);
    this.setState({ recordImages: recordImages, imageDetail: false });
  }
  addProduct() {
    let medias = [];
    this.state.recordImages.map((image, i) => medias.push(image.uid));
    let shop_uid = getShopUid();
    let params = {
      des: this.state.des,
      medias: medias,
      image: this.state.coverImage ? this.state.coverImage.uid : null,
      shop: shop_uid,
    };
    personalizedProduct(params).then((items) => {
      items && this.setState({ redirect: true });
    });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect push to={navigate_to_shop_from_url()} />;
    }
    return (
      <div className="container-fluid">
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0" }}
        >
          <div className="col-auto align-self-center px-0">
            <FiChevronRight
              size="26"
              className=""
              onClick={() => window.history.back()}
            />
          </div>
          <div className="col text-center align-self-center px-0">
            <h1 className="fs-5 fw-bolder mb-0">محصول سفارشی</h1>
          </div>
          <div className="col-auto text-center align-self-center px-0">
            <button
              onClick={() => this.addProduct()}
              className="btn fs-6 p-0 fw-bolder mb-0"
              disabled={!this.state.des}
              // disabled={!this.state.des || this.state.recordImages.length === 0}
            >
              ذخیره
            </button>
          </div>
        </header>
        <body style={{ marginTop: "80px" }}>
          <div className="row mx-0 px-0 mt-3">
            <div className="col-12 px-0">
              <textarea
                className="form-control rounded14 w-100 p-3"
                value={this.state.des}
                onChange={(e) => this.setState({ des: e.target.value })}
                rows="4"
                placeholder="توضیحات محصول (الزامی)"
              />
            </div>
          </div>

          <div className="row mx-0 px-0" style={{ marginTop: "8px" }}>
            <div className="col-12 px-0">
              <p className="fw-bolder">افزودن عکس</p>
            </div>
            <ImageUploading
              multiple={false}
              value={this.state.images}
              onChange={(imageList, addUpdateIndex) =>
                this.setState({ images: imageList }, () => this.addMedia())
              }
              maxNumber={20}
              dataURLKey="data_url"
            >
              {({
                imageList,
                onImageUpload,
                onImageRemoveAll,
                onImageUpdate,
                onImageRemove,
                isDragging,
                dragProps,
              }) => (
                <section className="row mx-0 px-0">
                  <div
                    className="col-4 p-1"
                    style={{ height: "100px" }}
                    onClick={onImageUpload}
                  >
                    <div className="row mx-0 h-100 text-center bg-light-gray">
                      <div className="col px-0 align-self-center">
                        <img
                          className=""
                          src={require("../factor/icons/camera.svg").default}
                        />
                      </div>
                    </div>
                  </div>
                  {this.state.recordImages.length > 0 &&
                    this.state.recordImages.map((image, i) => (
                      <div
                        className={
                          "col-4 p-1 position-relative text-center rounded14 " +
                          (this.state.coverImage &&
                            this.state.coverImage.uid === image.uid &&
                            "border-2 border-main")
                        }
                        style={{ height: "100px" }}
                      >
                        <img
                          alt="camera"
                          style={{ maxWidth: "100%" }}
                          className="w-auto h-100 img-cover"
                          src={image.thumbnail}
                          onClick={() =>
                            this.setState({
                              imageIndex: i,
                              image: image,
                              imageDetail: true,
                            })
                          }
                        />
                      </div>
                    ))}
                </section>
              )}
            </ImageUploading>
          </div>
          {this.state.pending && <Spinner />}
        </body>
        <Modal
          dir="rtl"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom w-auto rounded-top-14"
          isOpen={this.state.imageDetail}
          toggle={() => this.setState({ imageDetail: false })}
        >
          <ModalBody className="p-4">
            {this.state.image &&
              this.state.coverImage &&
              this.state.image.uid !== this.state.coverImage.uid && (
                <div
                  className="row mx-0 p-3 border rounded14"
                  onClick={() =>
                    this.setState({
                      coverImage: this.state.image,
                      imageDetail: false,
                    })
                  }
                >
                  <div className="col-auto px-1 align-self-center">
                    <CgImage size={20} />
                  </div>
                  <div className="col px-2">
                    <p className="mb-0 fs-5 fw-bolder">تنظیم به عنوان کاور</p>
                  </div>
                  <div className="col-auto px-1 align-self-center">
                    <FiChevronLeft size={24} />
                  </div>
                </div>
              )}
            <div
              className="row mx-0 p-3 border rounded14 mt-3"
              onClick={() =>
                this.setState({ imageDetail: false, lightbox: true })
              }
            >
              <div className="col-auto px-1 align-self-center">
                <HiOutlineArrowsExpand size={20} />
              </div>
              <div className="col px-2">
                <p className="mb-0 fs-5 fw-bolder">نمایش تمام صفحه</p>
              </div>
              <div className="col-auto px-1 align-self-center">
                <FiChevronLeft size={24} />
              </div>
            </div>
            <div
              className="row mx-0 p-3 border border-danger text-danger rounded14 mt-3"
              onClick={() => this.imageRemove()}
            >
              <div className="col-auto px-1 align-self-center">
                <IoTrashBinOutline size={20} />
              </div>
              <div className="col px-2">
                <p className="mb-0 fs-6 fw-bolder">برای حذف عکس نگه دارید</p>
              </div>
              <div className="col-auto px-1 align-self-center">
                <FiChevronLeft size={24} />
              </div>
            </div>
          </ModalBody>
        </Modal>
        {this.state.lightbox && this.state.image && (
          <Lightbox
            mainSrc={this.state.image.file}
            onCloseRequest={() => this.setState({ lightbox: false })}
          />
        )}
      </div>
    );
  }
}

export default PersonalizedProduct;
